// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9t-0";
export var optionCard = "_9t-1";